import EE from 'eventemitter2'

export const EventEmitter = EE

export default EE
